import moment from 'moment';
import DatePicker from "vue2-datepicker";
import StoreGetter from "@/constants/StoreGetter";
import SweetAlertService from "@/service/SweetAlertService";
import { StaffBenefits } from "@/model/StaffBenefits";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import UserEmployeeValidationObj from "./UserEmployeeValidation.js";
import Settings from '../../../../constants/Settings.js';
import UserService from "@/service/UserService";
import UserGroupService from "@/service/UserGroupService";
import StaffEmploymentService from "@/service/StaffEmploymentService";
import StaffService from "@/service/StaffService";
var UserEmpValidationObj = new UserEmployeeValidationObj();
export default {
    name: "userEmployee",
    components: {
        DatePicker
    },
    props: [
        "staffModel", "isViewMode",
    ],
    data: () => ({
        t: t,
        dictEnum: dictEnum,
        Settings: Settings,
        langList: [],
        userGroupList: [],
        selectedUser: {},
        departmentList: [],
        supervisorList: [],
    }),
    computed: {
        user() {
            return this.$store.getters[StoreGetter.user];
        },
        SupervisorList() {
            let list = this.supervisorList;
            if (this.staffModel.StaffID) {
                list = list.filter(
                    staff =>
                        staff.StaffID != this.staffModel.StaffID &&
                        staff.CompCode == this.staffModel.CompCode &&
                        staff.StaffType == 'S'
                )
            }
            return list;
        }
    },
    mounted() {
        UserEmpValidationObj.UserEmployeeValidation();
        this.getLangList();
        this.getUserGroupList();
        this.getUserEmployee();
        this.getStaffList();
        this.getDepartmentList();
    },
    methods: {
        async getLangList() {
            this.langList = [
                { CDesc: "英文", EDesc: "English", value: "EN" },
                { CDesc: "繁體中文", EDesc: "Traditional Chinese", value: "TC" },
                { CDesc: "简体中文", EDesc: "Simplified Chinese", value: "SC" }
            ];
        },

        async getStaffList() {
            const obj = {
                staffID: this.staffModel.StaffID
            };
            const response = await StaffService.getAllStaff(obj);
            if (response.data.IsSuccess) {
                const data = response.data.Data;
                this.supervisorList = data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },

        async getDepartmentList() {
            var obj = {};
            const response = await StaffEmploymentService.getAllDepartment(obj);
            if (response.data.IsSuccess) {
                this.departmentList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },

        async getUserGroupList() {
            const obj = {};
            const response = await UserGroupService.getUserGroups(obj);
            if (response.data.IsSuccess) {
                this.userGroupList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },

        async getUserEmployee() {
            const obj = {
                userId: this.staffModel.StaffID
            };
            const response = await UserService.getUserById(obj);
            if (response.data.IsSuccess) {
                this.selectedUser = response.data.Data;
                this.selectedUser.DateResign = this.selectedUser.DateResign
                    ? this.selectedUser.DateResign
                    : "";
                this.selectedUser.DeptsAlw = response.data.Data.DeptsAlw
                    ? response.data.Data.DeptsAlw.split(",")
                    : [];
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },

        async addOrUpdateUser() {
            const valid = await this.$validator.validateAll();
            const self = this;
            if (!valid) {
                SweetAlertService.warning(
                    "Warn",
                    self.t.t(dictEnum.MSG_ValidationFailed)
                );
                return;
            }

            if (!this.selectedUser.Lang) {
                SweetAlertService.warning("Warn", t.t(dictEnum.LBL_Language) + t.t(dictEnum.WARN_IsRequired));
                return;
            }

            if (this.selectedUser.Pwd !== this.selectedUser.ConfirmPwd) {
                SweetAlertService.warning(
                    "Warn",
                    this.t.t(dictEnum.WARN_PasswordNotMatch)
                );
                return;
            }

            if (this.selectedUser.UserGrpsList.length == 0) {
                SweetAlertService.warning(
                    "Warn",
                    this.t.t(dictEnum.LBL_UserGrp) + this.t.t(dictEnum.WARN_IsRequired)
                );
                return;
            }
            this.selectedUser.DateResign = this.selectedUser.DateResign
                ? moment(this.selectedUser.DateResign).format(
                    Settings.DateTime.yyyymmdd
                )
                : "1900-01-01";

            this.selectedUser.DeptsAlw = String(this.selectedUser.DeptsAlw);

            const obj = {
                model: this.selectedUser
            };

            const res = await UserService.updateUser(obj);
            if (res.data.IsSuccess) {
                SweetAlertService.success("Success", res.data.Message);
                this.getUserEmployee();
            } else {
                SweetAlertService.warning("Warn", res.data.Message);
            }

        },
    }
}



// WEBPACK FOOTER //
// ./src/components/S070000-Employee/S070200-EmployeeProfile/UserEmployee/UserEmployee.js